import { EAvailability } from '@r1-frontend/api-domru/api-loyalty/v1/program/availability';

interface ISubItem {
    text: string,
    sum?: number,
}

interface ICheque {
    text: string,
    url: string,
}

export interface ICharge {
    name: string,
    sum: number,
    oldSum: number,
    subItems: ISubItem[],
}

export interface IPay {
    name: string,
    sum: number,
    date: string,
    time: string,
    description: string,
    cheque: ICheque | null,
}

export enum ELoadingStatus {
    notInit,
    loading,
    success,
    error,
}

export interface ILoyaltyOperation {
    operationTime: string,
    operationDate: string,
    categoryName: string,
    operationValue: number,
}

export interface IPeriod {
    value: string, // 'DD.MM.YYYY'
    label: string, // '20 сен 2023 - 23 окт 2023'
    dateFrom: string,
    dateTo: string,
}

export const nullablePeriod = {
    value: '',
    label: '',
    dateFrom: '',
    dateTo: '',
};

export interface IHistory {
    payments: IPay[],
    paymentsTotalSum: number,
    charges: ICharge[],
    chargesTotalSum: number,
    loyaltyOperations: ILoyaltyOperation[],
    loyaltyAvailable: EAvailability,
    loadingStatus: ELoadingStatus,
    errorMsg: string,
}

export const initHistory: IHistory = {
    payments: [],
    paymentsTotalSum: 0,
    charges: [],
    chargesTotalSum: 0,
    loyaltyOperations: [],
    loyaltyAvailable: EAvailability.UNAVAILABLE,
    loadingStatus: ELoadingStatus.notInit,
    errorMsg: '',
};

export interface IBalanceHistoryState {
    historyByPeriod: Record<string, IHistory>,

    periods: IPeriod[],
    currentPeriod: IPeriod,
    isPeriodsLoading: boolean,
    isAllPeriodsFetched: boolean,
    periodError: string,
}

export const initialState: IBalanceHistoryState = {
    historyByPeriod: {},
    periods: [],
    isPeriodsLoading: false,
    currentPeriod: nullablePeriod,
    isAllPeriodsFetched: false,
    periodError: '',
};
